import React from 'react';
import LessonContainer from '../LessonContainer';

export default function EditorTabContent({
  containers, editorContents,
  setMainEditor, setActiveEditorHandler, addEditorToMap,
  getContainerContentChangeHandler,
  isStudent, lessonMode, remote, isFollowMode, isStudentLocked,
  moveContainerUp, moveContainerDown, deleteContainer, addContainer,
}) {
  // console.log('Rendering containers:', containers);
  return (
    <div data-tour="lesson-editor" style={{ position: 'relative', paddingTop: '32px' }}>
      {containers.map((container, index) => {
        // Получаем сохраненное содержимое для этого контейнера
        const containerContent = editorContents[`container-${container.id}`] || '';

        // console.log(`Rendering container ${container.id} with content:`, containerContent);
        // console.log(`Container type:`, container.type);

        return (
          <div
            key={container.id}
            // ОТКЛЮЧЕНО: drag and drop атрибуты
            // draggable
            // onDragStart={(e) => handleDragStart(e, container.id)}
            // onDragOver={handleDragOver}
            // onDrop={(e) => handleDrop(e, container.id)}
            // onDragEnd={handleDragEnd}
            // style={{
            //   cursor: 'move',
            //   opacity: draggedContainer === container.id ? 0.5 : 1
            // }}
          >
            <div style={{ position: 'relative' }}>
              <LessonContainer
                id={container.id}
                setMainEditor={setMainEditor}
                setActiveEditorId={setActiveEditorHandler}
                addEditorToMap={addEditorToMap}
                initialContent={containerContent}
                onContentChange={getContainerContentChangeHandler(container.id)}
                isStudent={isStudent}
                lessonMode={lessonMode}
                liveContent={isStudent
                  // Student-side: mirror teacher's typing live so the
                  // student watches the lesson unfold as the teacher
                  // writes. Read from remote.editorContents.
                  ? (remote?.editorContents?.[`container-${container.id}`] || null)
                  // Teacher-side: outside Follow Mode, students can type
                  // independently — mirror their live typing back so the
                  // teacher can see it too, same as the whiteboard
                  // already lets both sides work at once. This used to
                  // wipe the teacher's caret on every student keystroke;
                  // TextEditor's live-content effect is now focus-aware
                  // (it skips applying remote content while this editor
                  // is focused, and re-tries on blur), so it's safe.
                  // Follow Mode still means "teacher drives" — no
                  // mirroring back in that direction.
                  : (!isFollowMode ? (remote?.studentEditorContents?.[`container-${container.id}`] || null) : null)}
                isStudentLocked={isStudentLocked}
                sectionType={container.sectionType}
                sectionTitle={container.sectionTitle}
                sectionColor={container.sectionColor}
                sectionMinutes={container.sectionMinutes}
              />
              {/* Кнопки перемещения */}
              <button
                onClick={() => moveContainerUp(container.id)}
                onMouseEnter={(e) => {
                  const svg = e.target.querySelector('svg');
                  if (svg) svg.style.fill = '#ee5a24';
                }}
                onMouseLeave={(e) => {
                  const svg = e.target.querySelector('svg');
                  if (svg) svg.style.fill = '#ccc';
                }}
                title="Move container up"
                style={{
                  position: 'absolute',
                  top: 12,
                  right: 40,
                  width: 25,
                  height: 25,
                  background: 'transparent',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  zIndex: 100,
                  transition: 'all 0.2s ease'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 512 512" fill="#ccc" xmlns="http://www.w3.org/2000/svg">
                  <path d="m505.646 388.491c-4.237 4.237-9.788 6.356-15.341 6.356s-11.104-2.119-15.341-6.356l-218.964-218.964-218.964 218.964c-8.475 8.475-22.208 8.475-30.682 0-8.472-8.47-8.472-22.208 0-30.678l234.305-234.307c8.475-8.47 22.208-8.47 30.682 0l234.305 234.307c8.472 8.47 8.472 22.207 0 30.678z"/>
                </svg>
              </button>
              <button
                onClick={() => moveContainerDown(container.id)}
                onMouseEnter={(e) => {
                  const svg = e.target.querySelector('svg');
                  if (svg) svg.style.fill = '#ee5a24';
                }}
                onMouseLeave={(e) => {
                  const svg = e.target.querySelector('svg');
                  if (svg) svg.style.fill = '#ccc';
                }}
                title="Move container down"
                style={{
                  position: 'absolute',
                  top: 12,
                  right: 67,
                  width: 25,
                  height: 25,
                  background: 'transparent',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  zIndex: 100,
                  transition: 'all 0.2s ease'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 512 512" fill="#ccc" xmlns="http://www.w3.org/2000/svg">
                  <path d="m505.646 154.188-234.305 234.303c-4.237 4.237-9.788 6.356-15.341 6.356s-11.104-2.119-15.341-6.356l-234.305-234.303c-8.472-8.472-8.472-22.21 0-30.682 8.475-8.47 22.208-8.47 30.682 0l218.964 218.964 218.964-218.964c8.475-8.47 22.208-8.47 30.682 0 8.472 8.473 8.472 22.21 0 30.682z"/>
                </svg>
              </button>
              {/* Кнопка удаления */}
              <button
                onClick={() => deleteContainer(container.id)}
                onMouseEnter={(e) => {
                  const svg = e.target.querySelector('svg');
                  if (svg) svg.style.fill = '#ee5a24';
                }}
                onMouseLeave={(e) => {
                  const svg = e.target.querySelector('svg');
                  if (svg) svg.style.fill = '#ccc';
                }}
                title="Delete container"
                style={{
                  position: 'absolute',
                  top: 12,
                  right: 12,
                  width: 21,
                  height: 25,
                  background: 'transparent',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 18,
                  cursor: 'pointer',
                  zIndex: 100,
                  transition: 'color 0.2s ease'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 512 512" fill="#ccc" xmlns="http://www.w3.org/2000/svg">
                  <path d="m8.1 503.9c5.4 5.4 12.4 8.1 19.4 8.1s14-2.7 19.4-8.1l209.1-208.8 208.8 208.8c5.4 5.4 12.4 8.1 19.4 8.1s14-2.7 19.4-8.1c10.8-10.8 10.8-28.3 0-39.1l-208.5-208.8 208.8-208.8c10.8-10.8 10.8-28.3 0-39.1s-28.3-10.8-39.1 0l-208.8 208.8-208.8-208.8c-10.8-10.8-28.3-10.8-39.1 0s-10.8 28.3 0 39.1l208.8 208.8-208.8 208.8c-10.8 10.8-10.8 28.3 0 39.1z"/>
                </svg>
              </button>
            </div>
            {index === containers.length - 1 && (
              <button
                onClick={addContainer}
                className="add-container-button"
              >
                +
              </button>
            )}
          </div>
        );
      })}
      {/* Показываем кнопку добавления если нет контейнеров */}
      {containers.length === 0 && (
        <button
          onClick={addContainer}
          className="add-container-button"
          style={{ position: 'relative', top: '50px' }}
        >
          +
        </button>
      )}
    </div>
  );
}
